export const schema = {
    type: "object",
    properties: {
        collapsable: {
          type: "boolean"
        },
        config: {
            type: "object",
        },
        reportOptions: {
            type: "object",
            properties: {
                avoidPageBreak: {
                    type: "boolean"
                }
            },
            required: ["avoidPageBreak"],
            additionalProperties: false
        }
    },
    required: ["config"],
    additionalProperties: false
}